/*
 * Big Twin Store — « Trouver ma moto » v3 (section bts-vehicle-finder-v3)
 * Étapes : gamme, modèle, année, moteur / cylindrée (ordre réglable dans la section).
 * v3 : une étape vide affiche son libellé (« Gamme ») ; une étape remplie affiche
 *      le petit libellé au-dessus du choix.
 * Aucune dépendance. Chargé en defer. Un seul custom element par section.
 *
 * Événement émis après validation : document → 'bts:vehicle-change' (detail = moto).
 * Stockage partagé avec la v1 et la v2 : localStorage 'bts_garage'
 *   = { list: [{ fam, model, year, cc, ccl, fh, mh, ch }], active: 0 }
 *   cc = cylindrée telle que saisie (« 1690 (103) »), ccl = libellé affiché, ch = identifiant de collection.
 */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('bts-vehicle-finder-v3')) return;

  var MOBILE = window.matchMedia('(max-width: 767px)');
  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ESC[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); }
  /* Même règle que le filtre Liquid handleize : « 1690 (103) » → « 1690-103 » */
  function handleize(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  /* « 1994-2026 », « 2023 », « 2008- » (jusqu'à la dernière année de la gamme) */
  function rangeYears(txt, fallback) {
    var m = String(txt).trim().match(/^(\d{4})\s*(-)?\s*(\d{4})?$/);
    if (!m) return [];
    var a = +m[1];
    var b = m[3] ? +m[3] : (m[2] ? fallback[1] : a);
    var out = [];
    for (var y = Math.min(a, b); y <= Math.max(a, b); y++) out.push(y);
    return out;
  }
  /* « 1450 (88) / 1584 (96) » → ['1450 (88)', '1584 (96)'] ; « - » = pas de moteur à choisir */
  function splitCc(txt) {
    return String(txt).split('/').map(function (x) { return x.trim(); }).filter(function (x) { return x && x !== '-'; });
  }
  function ccNumber(label) { var m = String(label).match(/\d+/); return m ? +m[0] : 0; }

  /* Ligne de modèle, champ du milieu : « 1999-2006: 1450 (88), 2007-2016 » */
  function parseModelSpec(spec, fallback) {
    var years = {};
    var map = {};
    var any = false;
    String(spec || '').split(',').forEach(function (seg) {
      var i = seg.indexOf(':');
      var ys = rangeYears(i < 0 ? seg : seg.slice(0, i), fallback);
      if (!ys.length) return;
      any = true;
      var ccs = i < 0 ? null : splitCc(seg.slice(i + 1));
      ys.forEach(function (y) {
        years[y] = 1;
        if (ccs) map[y] = (map[y] || []).concat(ccs);
      });
    });
    if (!any) for (var y = fallback[0]; y <= fallback[1]; y++) years[y] = 1;
    return {
      years: Object.keys(years).map(Number).sort(function (a, b) { return b - a; }),
      map: map
    };
  }
  /* Bloc gamme, « Moteurs par années » : une ligne « 2007-2016: 1584 (96) / 1690 (103) » */
  function parseEngines(txt, fallback) {
    var rules = [];
    String(txt || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 0) return;
      var ys = [];
      line.slice(0, i).split(',').forEach(function (r) { ys = ys.concat(rangeYears(r, fallback)); });
      var ccs = splitCc(line.slice(i + 1));
      if (ys.length && ccs.length) rules.push({ years: ys, ccs: ccs });
    });
    return rules;
  }

  function readGarage(key) {
    try {
      var g = JSON.parse(localStorage.getItem(key));
      if (g && Array.isArray(g.list)) return g;
    } catch (e) { /* stockage indisponible */ }
    return { list: [], active: -1 };
  }
  function writeGarage(key, g) {
    try { localStorage.setItem(key, JSON.stringify(g)); } catch (e) { /* navigation privée */ }
  }

  class BtsVehicleFinderV3 extends HTMLElement {}
  var P = BtsVehicleFinderV3.prototype;

  P.connectedCallback = function () {
    if (this._on) return;
    this._on = true;
    var self = this;

    var raw = this.querySelector('script[data-tree]');
    try { this.tree = JSON.parse(raw ? raw.textContent : '[]'); } catch (e) { this.tree = []; }
    this.tree.forEach(function (f) {
      f.engines = parseEngines(f.e, f.y);
      f.models = (f.m || []).map(function (m) {
        var spec = parseModelSpec(m[2], f.y);
        return { n: m[0], h: m[1], years: spec.years, map: spec.map };
      });
    });

    this.key = this.dataset.storage || 'bts_garage';
    this.base = (this.dataset.root || '/').replace(/\/$/, '');
    this.section = this.closest('.bts-vf3') || this;
    this.panel = this.querySelector('[data-panel]');
    this.opts = this.querySelector('[data-opts]');
    this.titleEl = this.querySelector('[data-title]');
    this.hints = this.querySelectorAll('[data-hint]');
    this.backdrop = this.querySelector('[data-backdrop]');
    this.go = this.querySelector('[data-go]');
    this.stepEls = {};
    this.order = [];
    Array.prototype.forEach.call(this.querySelectorAll('[data-step]'), function (b) {
      self.stepEls[b.dataset.step] = b;
      self.order.push(b.dataset.step);
    });
    this.state = { fam: null, model: null, year: null, cc: null, open: null };
    this._items = [];

    this._click = this.onClick.bind(this);
    this._key = this.onKey.bind(this);
    this._outside = function (e) { if (self.state.open && !self.contains(e.target)) self.close(false); };
    this._blockSelect = function (e) { self.onEditorBlock(e, true); };
    this._blockDeselect = function (e) { self.onEditorBlock(e, false); };

    this.addEventListener('click', this._click);
    this.addEventListener('keydown', this._key);
    document.addEventListener('shopify:block:select', this._blockSelect);
    document.addEventListener('shopify:block:deselect', this._blockDeselect);

    this.checkQuickPicks();
    if (this.section.classList.contains('is-known')) this.fillKnown();
    this.render(false);
  };

  P.disconnectedCallback = function () {
    this.removeEventListener('click', this._click);
    this.removeEventListener('keydown', this._key);
    document.removeEventListener('pointerdown', this._outside);
    document.removeEventListener('shopify:block:select', this._blockSelect);
    document.removeEventListener('shopify:block:deselect', this._blockDeselect);
    document.documentElement.classList.remove('bts-vf3-lock');
    this._on = false;
  };

  /* ---------- Données : combinaisons modèle × année × cylindrée d'une gamme ---------- */
  P.rows = function (f) {
    if (!f) return [];
    if (f._rows) return f._rows;
    var rows = [];
    f.models.forEach(function (m) {
      m.years.forEach(function (y) {
        var ccs;
        if (m.map[y]) ccs = m.map[y];
        else {
          ccs = [];
          f.engines.forEach(function (r) { if (r.years.indexOf(y) > -1) ccs = ccs.concat(r.ccs); });
        }
        var seen = {};
        ccs = ccs.filter(function (c) { if (seen[c]) return false; seen[c] = 1; return true; });
        if (!ccs.length) rows.push({ m: m, y: y, c: null });
        else ccs.forEach(function (c) { rows.push({ m: m, y: y, c: c }); });
      });
    });
    f._rows = rows;
    return rows;
  };

  P.prior = function (key) { return this.order.slice(0, this.order.indexOf(key)); };

  /* Options d'une étape, filtrées par les étapes qui la précèdent */
  P.options = function (key) {
    var s = this.state;
    if (key === 'fam') return this.tree.map(function (f) { return { val: f, label: f.n }; });
    if (!s.fam) return [];
    var before = this.prior(key);
    var rows = this.rows(s.fam).filter(function (r) {
      for (var i = 0; i < before.length; i++) {
        var k = before[i];
        if (k === 'model' && r.m !== s.model) return false;
        if (k === 'year' && r.y !== s.year) return false;
        if (k === 'cc' && s.cc && r.c !== s.cc) return false;
      }
      return true;
    });
    var self = this;
    if (key === 'model') {
      return s.fam.models.filter(function (m) { return rows.some(function (r) { return r.m === m; }); })
        .map(function (m) { return { val: m, label: m.n }; });
    }
    if (key === 'year') {
      var ys = {};
      rows.forEach(function (r) { ys[r.y] = 1; });
      return Object.keys(ys).map(Number).sort(function (a, b) { return b - a; })
        .map(function (y) { return { val: y, label: String(y) }; });
    }
    if (key === 'cc') {
      var cs = {};
      rows.forEach(function (r) { if (r.c) cs[r.c] = 1; });
      return Object.keys(cs).sort(function (a, b) { return ccNumber(a) - ccNumber(b) || a.localeCompare(b); })
        .map(function (c) { return { val: c, label: self.ccLabel(c) }; });
    }
    return [];
  };

  P.ccLabel = function (c) {
    if (!c) return '';
    if (this.dataset.ccFormat !== 'pretty') return c;
    var m = String(c).match(/^(\d{3,4})\s*\((\d{2,3})\)$/);
    if (m) return m[1] + ' cm³ (' + m[2] + ' ci)';
    if (/^\d{3,4}$/.test(String(c).trim())) return String(c).trim() + ' cm³';
    return c;
  };

  /* Version courte pour le bouton d'étape (la liste et la carte gardent le libellé complet) */
  P.ccShort = function (c) {
    if (!c) return '';
    if (this.dataset.ccFormat !== 'pretty') return c;
    var m = String(c).match(/^(\d{3,4})\b/);
    return m ? m[1] + ' cm³' : c;
  };

  P.done = function (key) {
    var s = this.state;
    if (key === 'cc') return s.cc !== null;
    return !!s[key];
  };
  P.allDone = function () {
    for (var i = 0; i < this.order.length; i++) if (!this.done(this.order[i])) return false;
    return true;
  };
  P.reset = function (key) { this.state[key] = null; };

  /* Après un choix : vide les étapes suivantes, saute celles qui n'ont qu'une réponse */
  P.advance = function (fromKey) {
    var s = this.state;
    var idx = this.order.indexOf(fromKey);
    for (var j = idx + 1; j < this.order.length; j++) this.reset(this.order[j]);
    s.open = null;
    for (var k = idx + 1; k < this.order.length; k++) {
      var key = this.order[k];
      var opts = this.options(key);
      if (key === 'cc' && !opts.length) { s.cc = ''; continue; }
      if (opts.length === 1) { s[key] = opts[0].val; continue; }
      s.open = key;
      return;
    }
  };

  /* ---------- URL de destination ---------- */
  P.url = function (v) {
    var t = this.dataset.template || '/collections/{modele}';
    t = t.replace(/\{gamme\}/g, v.fh || '')
         .replace(/\{modele\}/g, v.mh || v.fh || '')
         .replace(/\{annee\}/g, v.year || '')
         .replace(/\{cylindree\}/g, v.ch || '');
    return (t.charAt(0) === '/' && t.charAt(1) !== '/') ? this.base + t : t;
  };
  P.vehicle = function () {
    var s = this.state;
    return {
      fam: s.fam.n, model: s.model.n, year: s.year,
      cc: s.cc || '', ccl: this.ccLabel(s.cc),
      fh: s.fam.h, mh: s.model.h, ch: s.cc ? handleize(s.cc) : ''
    };
  };

  /* ---------- Rendu ---------- */
  P.render = function (focus) {
    var s = this.state;
    var none = this.dataset.ccNone || '';
    var enabled = true;
    for (var i = 0; i < this.order.length; i++) {
      var key = this.order[i];
      var value = null;
      if (key === 'fam' && s.fam) value = s.fam.n;
      if (key === 'model' && s.model) value = s.model.n;
      if (key === 'year' && s.year) value = String(s.year);
      if (key === 'cc' && s.cc !== null) value = s.cc ? this.ccShort(s.cc) : none;
      var naCc = key === 'cc' && s.cc === '';
      this.setStep(key, value, enabled && !naCc);
      if (!this.done(key)) enabled = false;
    }

    if (this.allDone()) {
      this.go.href = this.url(this.vehicle());
      this.go.removeAttribute('aria-disabled');
      this.go.removeAttribute('role');
    } else {
      this.go.removeAttribute('href');
      this.go.setAttribute('aria-disabled', 'true');
      this.go.setAttribute('role', 'link');
    }
    this.renderPanel(focus);
  };

  P.setStep = function (key, value, enabled) {
    var el = this.stepEls[key];
    if (!el) return;
    el.disabled = !enabled;
    el.classList.toggle('is-open', this.state.open === key);
    el.classList.toggle('is-done', this.done(key));
    el.setAttribute('aria-expanded', String(this.state.open === key));
    var empty = value === null;
    var label = el.querySelector('[data-label]');
    var text = empty ? (label ? label.textContent : '') : value;
    el.classList.toggle('is-empty', empty);
    var v = el.querySelector('[data-value]');
    if (v) {
      v.textContent = text;
      v.title = key === 'cc' && this.state.cc ? this.ccLabel(this.state.cc) : text;
    }
  };

  P.renderPanel = function (focus) {
    var s = this.state;
    var open = s.open;
    var sheet = MOBILE.matches && this.section.classList.contains('bts-vf3--sheet');
    if (!open) {
      this.panel.hidden = true;
      if (this.backdrop) this.backdrop.hidden = true;
      document.documentElement.classList.remove('bts-vf3-lock');
      document.removeEventListener('pointerdown', this._outside);
      return;
    }

    var items = this.options(open);
    this._items = items;
    var d = this.dataset;
    var title = { fam: d.tFam, model: d.tModel, year: d.tYear, cc: d.tCc }[open] || '';
    title = title.replace('{gamme}', s.fam ? s.fam.n : '')
                 .replace('{modele}', s.model ? s.model.n : '')
                 .replace('{annee}', s.year ? s.year : '')
                 .replace(/\s{2,}/g, ' ').trim();

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var on = s[open] === items[i].val;
      html += '<button type="button" class="bts-vf3__opt" data-val="' + i + '" aria-pressed="' + on + '">' + esc(items[i].label) + '</button>';
    }
    this.panel.setAttribute('data-kind', open);
    this.titleEl.textContent = title;
    this.opts.innerHTML = html;
    Array.prototype.forEach.call(this.hints, function (h) { h.hidden = h.getAttribute('data-hint') !== open; });
    this.panel.hidden = false;
    this.panel.scrollTop = 0;
    if (this.backdrop) this.backdrop.hidden = !sheet;
    document.documentElement.classList.toggle('bts-vf3-lock', sheet);
    document.addEventListener('pointerdown', this._outside);

    if (focus) {
      var target = this.opts.querySelector('[aria-pressed="true"]') || this.opts.firstElementChild;
      if (target) target.focus({ preventScroll: !sheet });
    }
  };

  /* ---------- Interactions ---------- */
  P.onClick = function (e) {
    if (e.target.hasAttribute && e.target.hasAttribute('data-backdrop')) { this.close(true); return; }
    var t = e.target.closest('button, a');
    if (!t || !this.contains(t)) return;
    var s = this.state;

    if (t.dataset.step) {
      s.open = s.open === t.dataset.step ? null : t.dataset.step;
      this.render(!!s.open);
      return;
    }
    if (t.hasAttribute('data-val')) { this.pick(+t.getAttribute('data-val')); return; }
    if (t.hasAttribute('data-close')) { this.close(true); return; }
    if (t.hasAttribute('data-go')) {
      if (t.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        for (var i = 0; i < this.order.length; i++) {
          if (!this.done(this.order[i])) { s.open = this.order[i]; break; }
        }
        this.render(true);
        return;
      }
      this.save();
      return;
    }
    if (t.hasAttribute('data-quick')) { this.quick(t); return; }
    if (t.hasAttribute('data-change')) {
      this.showSelector();
      s.open = 'fam';
      this.render(true);
    }
  };

  P.pick = function (index) {
    var s = this.state;
    var key = s.open;
    var item = this._items[index];
    if (!key || !item) return;
    var changed = s[key] !== item.val;
    s[key] = item.val;
    if (changed) this.advance(key);
    else {
      s.open = null;
      for (var i = this.order.indexOf(key) + 1; i < this.order.length; i++) {
        if (!this.done(this.order[i])) { s.open = this.order[i]; break; }
      }
    }
    this.render(true);
    if (!s.open) this.go.focus();
  };

  P.close = function (restoreFocus) {
    var was = this.state.open;
    this.state.open = null;
    this.render(false);
    if (restoreFocus && was && this.stepEls[was]) this.stepEls[was].focus();
  };

  P.onKey = function (e) {
    if (e.key === 'Escape' && this.state.open) { e.preventDefault(); this.close(true); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target === this.go && this.go.getAttribute('aria-disabled') === 'true') {
      e.preventDefault(); this.go.click(); return;
    }
    var opt = e.target.closest && e.target.closest('.bts-vf3__opt');
    if (!opt) return;
    var list = Array.prototype.slice.call(this.opts.children);
    var i = list.indexOf(opt);
    var cols = getComputedStyle(this.opts).gridTemplateColumns.split(' ').length || 1;
    var moves = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: cols, ArrowUp: -cols, Home: -i, End: list.length };
    if (!(e.key in moves)) return;
    e.preventDefault();
    var next = list[Math.max(0, Math.min(list.length - 1, i + moves[e.key]))];
    if (next) next.focus();
  };

  /* Moto populaire : remplit ce qui correspond, ouvre la première étape à compléter */
  P.quick = function (btn) {
    var s = this.state;
    var want = { fam: norm(btn.dataset.fam), model: norm(btn.dataset.model), year: +btn.dataset.year || null, cc: norm(btn.dataset.cc) };
    var f = this.tree.filter(function (x) { return norm(x.n) === want.fam || norm(x.h) === want.fam; })[0];
    if (!f) return;
    s.fam = f;
    this.advance('fam');
    for (var i = 1; i < this.order.length; i++) {
      var key = this.order[i];
      if (this.done(key)) continue;
      var opts = this.options(key);
      var hit = opts.filter(function (o) {
        if (key === 'model') return norm(o.val.n) === want.model;
        if (key === 'year') return o.val === want.year;
        if (key === 'cc') return want.cc && norm(o.val) === want.cc;
        return false;
      })[0];
      if (!hit) { s.open = key; break; }
      s[key] = hit.val;
      this.advance(key);
      if (s.open === null && this.allDone()) break;
    }
    this.render(!!s.open);
    if (!s.open) {
      if (this.dataset.quickMode === 'go') { this.save(); window.location.href = this.go.href; }
      else this.go.focus();
    }
  };

  /* Masque les pastilles qui ne correspondent à aucune ligne du sélecteur */
  P.checkQuickPicks = function () {
    var self = this;
    Array.prototype.forEach.call(this.querySelectorAll('[data-quick]'), function (btn) {
      var fam = norm(btn.dataset.fam), model = norm(btn.dataset.model);
      var ok = self.tree.some(function (f) {
        return (norm(f.n) === fam || norm(f.h) === fam) && f.models.some(function (m) { return norm(m.n) === model; });
      });
      btn.hidden = !ok;
    });
  };

  /* ---------- Mon garage ---------- */
  P.save = function () {
    if (!this.allDone()) return;
    var v = this.vehicle();
    if (this.dataset.remember !== 'false') {
      var g = readGarage(this.key);
      g.list = g.list.filter(function (x) { return !(x.fam === v.fam && x.model === v.model && x.year === v.year && (x.cc || '') === v.cc); });
      g.list.unshift(v);
      g.list = g.list.slice(0, 5);
      g.active = 0;
      writeGarage(this.key, g);
    }
    document.dispatchEvent(new CustomEvent('bts:vehicle-change', { detail: v }));
  };

  P.fillKnown = function () {
    var known = this.querySelector('.bts-vf3__known');
    if (!known) return;
    var g = readGarage(this.key);
    var v = g.list[g.active > -1 ? g.active : 0];
    var link = known.querySelector('[data-known-go]');
    if (v && v.model) {
      var name = known.querySelector('[data-bike]');
      var cc = known.querySelector('[data-bike-cc]');
      if (name && !name.textContent) name.textContent = v.model + ' ' + v.year;
      if (cc && !cc.textContent && (v.ccl || v.cc)) { cc.textContent = v.ccl || v.cc; cc.hidden = false; }
      if (link && !link.getAttribute('href')) link.href = this.url(v);
      if (link) link.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('bts:vehicle-change', { detail: v }));
      }, { once: true });
    }
  };

  P.showSelector = function () {
    this.section.classList.remove('is-known');
    var known = this.querySelector('.bts-vf3__known');
    if (known) known.hidden = true;
  };

  /* ---------- Éditeur de thème : clic sur un bloc « Gamme » ---------- */
  P.onEditorBlock = function (e, selected) {
    var d = e.detail || {};
    if (d.sectionId !== this.dataset.section) return;
    var f = null;
    for (var i = 0; i < this.tree.length; i++) if (this.tree[i].id === d.blockId) f = this.tree[i];
    if (!f) return;
    if (!selected) { this.close(false); return; }
    this.showSelector();
    this.state = { fam: f, model: null, year: null, cc: null, open: null };
    this.advance('fam');
    this.render(false);
  };

  customElements.define('bts-vehicle-finder-v3', BtsVehicleFinderV3);
})();